export const version = "14.7.12";
//# sourceMappingURL=version.js.map